import React from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import { getEmailCount } from '../../store/email/sagas';
import { useTranslation } from 'react-i18next';

interface Props {
  token: string;
}

const EmailSending: React.FC<Props> = ({ token }) => {
  const { t, i18n } = useTranslation();
  return (
    <ProgressBar
      title={t('Sending emails...')}
      fetchValue={async () => {
        const response = await getEmailCount(token);
        if (response.type === 'ok') {
          const { total, processed } = response.value.data;
          return total ? Math.floor((processed / total) * 100) : 0;
        }
        return 0;
      }}
    />
  );
};

export default EmailSending;
